/** @format */

import { screenSize } from './breakpoints';

/**
 * React ionic breakpoints
 */
export const ScreenSize = {
  Small: '576px',
  Medium: '768px',
  Large: '992px',
  ExtraLarge: '1200px',
};

/**
 * Example Usage:
 * import styled from 'styled-components';
 * import globalStyles from 'path/to-here/global-styles/theme';
 *
 *  [GlobalStyles.Device.Tablet] {
 *    height: ${tabletHeight};
 *  }
 * `;
 */
export const Device = {
  Mobile: `@media (max-width: ${screenSize.Small}`,
  Tablet: `@media (max-width: ${screenSize.Medium})`,
  Laptop: `@media (min-width: ${screenSize.Large})`,
};

export default Device;
